import(/* webpackMode: "eager" */ "/root/repo/src/app/score-check/projects/page.tsx");
